import { createSlice } from "@reduxjs/toolkit";
import { ISession } from "../interface/ISession";

const initialState: ISession | null = null;

const sessionSlice = createSlice({
  name: "session",
  initialState,
  reducers: {
    setSessionStore: (state: ISession | null, action: any | null) => {
      return action.payload;
    },
    setSessionNull: (state, action) => {
      return null;
    }
  },
});

export const { setSessionStore, setSessionNull } = sessionSlice.actions;

export default sessionSlice.reducer;
